import React, { useEffect } from 'react';
import MainLayout from '@/components/layout/MainLayout';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Management = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const services = t('management.services', { returnObjects: true }) as string[];

  return (
    <MainLayout>
      <section className="pt-32 pb-24 bg-[#2A2A2A] text-[#D9D9D9]">
        <div className="container-custom">
          <motion.h1
            className="text-4xl sm:text-5xl font-semibold font-poppins text-center mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {t('management.title')}
          </motion.h1>

          <motion.p
            className="max-w-3xl mx-auto text-center text-[#C0C0C0] text-lg mb-16"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            {t('management.intro')}
          </motion.p>

          <motion.div
            className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-20"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            transition={{ staggerChildren: 0.2 }}
          >
            {services.map((service, index) => (
              <motion.div
                key={index}
                className="flex items-start gap-4 text-[#CCCCCC] hover:text-[#C8102E] transition-colors"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
              >
                <CheckCircle size={24} className="mt-1 text-[#C8102E]" />
                <p className="text-base sm:text-lg leading-relaxed">{service}</p>
              </motion.div>
            ))}
          </motion.div>

          <motion.div
            className="bg-[#1E1E1E] border border-[#3A3A3A] rounded p-10 max-w-4xl mx-auto text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-2xl sm:text-3xl font-medium mb-4">
              {t('management.ctaTitle')}
            </h2>
            <p className="text-[#BBBBBB] mb-6">{t('management.ctaText')}</p>
            <a
              href="/contact"
              className="inline-block px-8 py-3 bg-[#5F5F5F] hover:bg-[#C8102E] text-white transition-colors font-medium"
            >
              {t('management.ctaButton')}
            </a>
          </motion.div>
        </div>
      </section>
    </MainLayout>
  );
};

export default Management;
